import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@app/core/model/enum/state.enum';

import {
  LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_LIST,
  LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ORDER,
  LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_VISIBILITY,
} from './location-charge-point-list-update-form-step-1.config';

export interface LocationChargePointListUpdateFormStep1ChargePointViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<GatewayChargePointModel>;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationOffsetNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
}

export const LocationChargePointListUpdateFormStep1ChargePointView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
}: LocationChargePointListUpdateFormStep1ChargePointViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // LIST //////////////////////////////////////////////////////////////////////

  const columns = useMemo(
    () => [...LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_LIST],
    [],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable<GatewayChargePointModel>
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={columns}
      columnOrder={LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ORDER}
      columnVisibility={
        LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_VISIBILITY
      }
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.charge-point-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
    />
  );
};
